import { render, staticRenderFns } from "./CartTabMenuItem.vue?vue&type=template&id=8fa902d8&scoped=true"
import script from "./CartTabMenuItem.vue?vue&type=script&lang=ts"
export * from "./CartTabMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa902d8",
  null
  
)

export default component.exports